import { useListResolvedTenantModules, getListResolvedTenantModulesQueryKey, type AgentAccessScope } from '@cdf/api-client-react';
import { promptTargetOptions } from './prompt-library-context';

/** Tenant administration uses the selected tenant, independently of the active entity. */
export function usePromptTargetOptions(scope: AgentAccessScope | null, identity: string, permissions: readonly string[], enabledModules: readonly string[]) {
  const tenant = scope?.kind === 'tenant' && permissions.includes('tenant.settings.manage');
  const tenantId = scope?.tenantId ?? '';
  const modules = useListResolvedTenantModules({
    request: { headers: { 'X-Tenant-Id': tenantId } },
    query: { queryKey: [...getListResolvedTenantModulesQueryKey(), tenantId, identity], enabled: Boolean(tenant && tenantId), retry: false }
  });
  const ready = !tenant || Boolean(modules.data && !modules.isError);
  return {
    options: promptTargetOptions(tenant ? ready ? modules.data!.items.filter(item => item.enabled).map(item => item.key) : [] : scope?.kind === 'entity' ? enabledModules : [], permissions, Boolean(tenant)),
    ready, error: tenant && modules.isError, retry: modules.refetch
  };
}
